import _ from "lodash";
import { Box, ListSubheader, MenuItem, MenuList, TextField, Typography, useMediaQuery } from "@mui/material";
import { theme } from "app/App";
import { filterGroupedList, filterListAny } from "components/DataFilter/filter";
import FormRow from "components/form/FormRow";
import { useEffect, useState } from "react";
import WindowDialog from "./WindowDialog";

/**
 * Um diálogo com uma lista de ações para ser selecionadas.
 *
 * menuItems é um array com objetos na forma:
 * {
 *     id: "id" (opcional)
 *     label: "conteúdo do rótulo"
 *     icon: <SvgIcon /> (opcional)
 * }
 *
 * TODO: ícones
 */
export default function MenuDialog({
    menuItems,
    showFilter = true,
    emptyMessage = "Nenhum item",
    setDialog,
    onClose,
    ...props
}) {
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const height = 450;

    const [dialog, _setDialog] = useState();
    const [filter, setFilter] = useState();
    const [filteredMenuItems, setFilteredMenuItems] = useState(menuItems);

    useEffect(() => {
        // Precisamos do estado do diálogo internamente, mas também exportar pelo prop quando necessário.
        if (setDialog) {
            setDialog(dialog);
        }
    }, [dialog, setDialog]);

    useEffect(() => {
        if (filter) {
            setFilteredMenuItems(
                menuItems && menuItems.length && menuItems[0].subheader
                    // Filtra lista agrupada, pelos campos de id, rótulo e subheader.
                    ? filterGroupedList(menuItems, {
                        id: { value: filter },
                        label: { value: filter },
                        subheader: { value: filter }
                    })
                    // Filtra por id e rótulo.
                    : filterListAny(menuItems, {
                        id: { value: filter },
                        label: { value: filter }
                    })
            )
        } else {
            setFilteredMenuItems(menuItems ?? []);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, menuItems]);

    function handleClose(...args) {
        setFilter(null);

        if (onClose) {
            onClose(...args);
        }
    }

    const ListWithSubheader = ({ dialogProps }) => {
        return filteredMenuItems.map((itemSubheader, index) => (
            <div key={index + itemSubheader.subheader}>
                <ListSubheader>{itemSubheader.subheader}</ListSubheader>
                {itemSubheader?.items?.map((item) => (
                    <MenuItem
                        key={item.id ?? item.label}
                        onClick={() => dialogProps.onClose(item)}
                        sx={{ p: 2, borderBottom: "1px dotted" }}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </div>
        ))
    }

    return (
        <WindowDialog
            height={fullScreen || !showFilter ? null : height}
            maxHeight={fullScreen ? null : height}
            maxWidth="xs"
            contentProps={{ sx: { p: 0 } }}
            onClose={handleClose}
            setDialog={_setDialog}
            {...props}
        >
            {(dialogProps) =>
                !_.isEmpty(menuItems) ? (
                    <Box sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                        {showFilter ? (
                            <FormRow sx={{ flex: 0, p: 2, borderBottom: "1px solid" }}>
                                <TextField
                                    sx={{ flex: 1 }}
                                    label="Filtrar"
                                    variant="outlined"
                                    onChange={(event) => setFilter(event.target.value)}
                                />
                            </FormRow>
                        ) : null}

                        <MenuList sx={{ flex: 1, p: 0, overflow: "auto" }}>
                            {menuItems && menuItems.length && menuItems[0].subheader
                                ? <ListWithSubheader dialogProps={dialogProps} />
                                : filteredMenuItems.map((item) => (
                                    <MenuItem
                                        key={item.id ?? item.label}
                                        onClick={() => dialogProps.onClose(item)}
                                        sx={{ p: 2, borderBottom: "1px dotted" }}
                                    >
                                        {item.label}
                                    </MenuItem>
                                ))
                            }
                        </MenuList>
                    </Box>
                ) : (
                    <Typography sx={{ p: 2 }}>{emptyMessage}</Typography>
                )
            }
        </WindowDialog>
    );
}
